import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

const MARKED_OPTIONS: marked.MarkedOptions = {
  gfm: true,
  breaks: true,     // coach responses separate lines with a single newline, not a blank one
  headerIds: false, // ids would only add noise to the chat DOM
  mangle: false,
};

// The typewriter effect streams a response one character at a time, so its tail often
// holds a half-typed marker ("**सुपरहिरो"). Marked renders an unpaired marker literally,
// which makes the asterisks flash on screen until the closing pair arrives.
function dropUnclosedStrong(text: string): string {
  const markers = (text.match(/\*\*/g) || []).length;
  if (markers % 2 === 0) return text;
  const last = text.lastIndexOf('**');
  return text.slice(0, last) + text.slice(last + 2);
}

export function markdownToHtml(value: string): string {
  if (!value) return '';
  try {
    return marked.parse(dropUnclosedStrong(value), MARKED_OPTIONS).trim();
  } catch {
    // Never blank out a bubble because of a malformed response — show the raw text.
    return value;
  }
}

/**
 * Renders the markdown the coach API returns (**bold**, *italic*, lists, headings)
 * as HTML. Inline HTML the caller already injected (post links, quill markup) passes
 * through untouched.
 *
 * Pure pipe, so it only re-parses when the message string itself changes. The result is
 * a plain string, which keeps Angular's own [innerHTML] sanitizer in the path.
 */
@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {

  transform(value: string): string {
    return markdownToHtml(value);
  }

}